export default __webpack_public_path__ + "static/media/stickermule.78702621.svg";